import { createApp } from './main'
import './styles/style.less'
import { printVersionInfo } from './version'
import * as Sentry from '@sentry/vue'

// 禁用浏览器原生滚动恢复，避免 SSR hydration 后页面自动滚动
if (typeof window !== 'undefined' && 'scrollRestoration' in history) {
  history.scrollRestoration = 'manual'
}

const { app, router, pinia } = createApp()

// 路由切换时滚动到顶部
router.afterEach(() => {
  window.scrollTo(0, 0)
})

// 初始化 Sentry (仅客户端)
if (import.meta.env.VITE_SENTRY_DSN) {
  console.log('[Sentry] Initializing on client, DSN:', import.meta.env.VITE_SENTRY_DSN)
  Sentry.init({
    app,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    sendDefaultPii: true,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.browserProfilingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      })
    ],
    // Tracing
    tracesSampleRate: 1.0,
    tracePropagationTargets: [
      'localhost',
      'www.luckystarry.com',
      'pre.luckystarry.com'
    ],
    // Profiling
    profileSessionSampleRate: 1.0,
    profileLifecycle: 'trace',
    // Logs
    enableLogs: true
  })
  console.log('[Sentry] Initialized successfully')
} else {
  console.warn('[Sentry] Client initialization skipped: VITE_SENTRY_DSN is not set')
  console.log('[Sentry] Available env vars:', {
    PROD: import.meta.env.PROD,
    MODE: import.meta.env.MODE,
    DEV: import.meta.env.DEV
  })
}

if (window.__INITIAL_STATE__) {
  if (typeof window.__INITIAL_STATE__ === 'string') {
    pinia.state.value = JSON.parse(window.__INITIAL_STATE__)
  } else {
    pinia.state.value = window.__INITIAL_STATE__
  }
}

if (import.meta.env.PROD) {
  app.config.errorHandler = (err, instance, info) => {
    console.error('Vue Error:', err)
    console.error('Component:', instance)
    console.error('Info:', info)
    // Sentry 会自动捕获未处理的异常,但我们可以添加额外的上下文信息
    Sentry.withScope((scope) => {
      scope.setContext('vue_component', {
        info,
        component: instance?.$options?.name || 'anonymous'
      })
      Sentry.captureException(err)
    })
  }
  app.config.performance = true
  app.config.warnHandler = (msg, instance, trace) => {
    console.warn('[Vue warn]:', msg)
    console.warn('Component trace:', trace)
  }
}

window.addEventListener('error', (event) => {
  console.error('Global error:', event.error)
  Sentry.captureException(event.error)
})

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled Promise rejection:', event.reason)
  Sentry.captureException(event.reason)
})

printVersionInfo()

router
  .isReady()
  .then(() => {
    app.mount('#app')
  })
  .catch((error) => {
    console.error('Router error:', error)
    Sentry.captureException(error)
  })
